<template>
  <div class="works-component sakura">
    <div class="banner"> 
      <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/00-hero banner.jpg" alt="">
    </div>
    <div class="border-bottom-white-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 white text-left m-0">
          樱 | Sakura
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-white-1px"> 
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/01-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/01-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/01-land-3.jpg" alt="">
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/02-full.jpg" alt="">
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/03-portrait-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/03-portrait-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/03-portrait-3.jpg" alt="">
        </b-col>
      </b-row>   
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/04-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/04-land-2.jpg" alt="">
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/05-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/05-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/05-land-3.jpg" alt="">
        </b-col>
      </b-row>  
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/06-portrait-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/06-portrait-2.jpg" alt="">
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/07-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/07-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/07-land-3.jpg" alt="">
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/08-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/08-land-2.jpg" alt="">
        </b-col>
      </b-row>  
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/09-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/09-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/09-land-3.jpg" alt="">
        </b-col>
      </b-row>   
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/10-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/10-land-2.jpg" alt="">
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/11-portrait-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/11-portrait-2.jpg" alt="">
        </b-col>
      </b-row> 
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="Serenity"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left_white.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 white  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 white p-0">悠 | Serenity</p>
              <p class="inter inter-body-md-400 white p-0">Sunway Mont | Mont Kiara</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 white  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 white p-0">云 | Cloud</p>
              <p class="inter inter-body-md-400 white p-0">Residensi 22 | Mont Kiara</p>
            </b-col>
            <b-col cols="3"  to="Cloud"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right_white.svg" alt=""></b-col>
          </b-row>
          
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
export default {
  name: 'sakuraLinkHouse',
  data() {
    return { 
    }
  },
  methods: { 
  }, 

}
</script>

<style>
 
.sakura{
  background-color: #787773 ;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.sakura p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}

@media (max-width: 576px) { 
}
</style>